import * as Sentry from '@sentry/angular';
import { ErrorHandler } from '@angular/core';
import { EnvironmentConfig } from '../models/apps-environment';

export function rsErrorHandlerFactory(environmentConfig: EnvironmentConfig): ErrorHandler {
  if (environmentConfig.enableSentryMonitoring) {
    return Sentry.createErrorHandler({
      showDialog: false,
      logErrors: false,
    });
  }
  return new ErrorHandler();
}